import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './pages/HomePage';
import Login from './admin/Login';
import AdminPanel from './admin/AdminPanel';
import styles from './App.module.css';

function App() {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [token, setToken] = useState(null);

    useEffect(() => {
        const savedToken = localStorage.getItem('token');
        if (savedToken) {
            setIsAuthenticated(true);
            setToken(savedToken);
        }
    }, []);

    const handleLogin = (newToken) => {
        setIsAuthenticated(true);
        setToken(newToken);
    };

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('username');
        setIsAuthenticated(false);
        setToken(null);
    };

    return (
        <Router>
            <div className={styles.app}>
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route
                        path="/admin"
                        element={
                            isAuthenticated ?
                                <AdminPanel token={token} onLogout={handleLogout} /> :
                                <Login onLogin={handleLogin} />
                        }
                    />
                </Routes>
            </div>
        </Router>
    );
}

export default App;